import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import accessGroupMemberships from 'modules/dashboard/store/collections/AccessGroupMemberships'
import groups from 'modules/dashboard/store/collections/communities/Groups'

export default function useGroupMemberships(groupId: number) {
  return useAsyncData(async () => {
    await groups.fetch({
      data: {
        id: groupId,
      },
      remove: false,
    })

    const group = groups.find({
      id: groupId,
    })

    if (!group) return

    await accessGroupMemberships.fetch({
      data: {
        access_group_id: group.attributes.access_group_id,
      },
      remove: false,
    })
  }, [groupId])
}
